<template>
  <DsNumberedInfoSection
    title="¿Cómo te ayuda la liquidación?"
    title-id="liquidacion-help-title"
    intro="Te permite alcanzar la libertad financiera y la total propiedad de tu hogar (en liquidación total) o reducir tus preocupaciones y obtener mayor alivio en tus finanzas mensuales (en liquidación parcial)."
    :items="helpSteps"
  />
</template>

<script setup lang="ts">
import DsNumberedInfoSection from '../components/DsNumberedInfoSection.vue'

const helpSteps = [
  {
    id: 'amount-request',
    title: 'Solicitud de Montos',
    description:
      'Comunícate con nosotros para conocer el monto exacto de tu liquidación ' +
      'parcial o total. Estaremos encantados de orientarte con este trámite.'
  },
  {
    id: 'payment',
    title: 'Realización del Pago',
    description:
      'Efectúa el pago correspondiente a la modalidad elegida para avanzar ' +
      'hacia la liberación de tu hipoteca o la reducción de tus mensualidades.'
  },
  {
    id: 'mortgage-release',
    title: 'Liberación y Cancelación de Hipoteca (Liquidación Total)',
    description:
      'Una vez concretada tu liquidación total, inicia el proceso de liberación ' +
      'y cancelación de hipoteca enviando tu solicitud y documentación ' +
      'directamente al correo de gestión: cancelacionhipoteca@hircasa.com.mx.',
    descriptionHtml:
      'Una vez concretada tu liquidación total, inicia el proceso de ' +
      '<strong>liberación y cancelación de hipoteca</strong> enviando tu ' +
      'solicitud y documentación directamente al correo de gestión: ' +
      'cancelacionhipoteca@hircasa.com.mx.'
  },
  {
    id: 'continuity',
    title: 'Continuidad (si aplica)',
    description:
      'Si optaste por liquidación parcial, recuerda la importancia de seguir ' +
      'pagando puntualmente los contratos que aún mantengas activos para ' +
      'asegurar una experiencia impecable.'
  }
]
</script>
